// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/base.css'
import VeBar from 'v-charts/lib/bar.common'
import VeWordcloud from 'v-charts/lib/wordcloud.common'
import VeRing from 'v-charts/lib/ring.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import VeLine from 'v-charts/lib/line.common'
import { browser } from './config/ua'
import { routeToMobile } from './config/mobileRedirection'
import { getToken, getParams } from './service/getData'
import './utils'
import { performance } from './utils/performance'
import { Loading } from 'element-ui'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Vant);
Vue.component(VeBar.name, VeBar)
Vue.component(VeWordcloud.name, VeWordcloud)
Vue.component(VeRing.name, VeRing)
Vue.component(VeHistogram.name, VeHistogram)
Vue.component(VeLine.name, VeLine)

// 针对IE不自主跳转的问题
if (!!window.ActiveXObject || 'ActiveXObject' in window) {
  window.addEventListener('hashchange', () => {
    let currentPath = window.location.hash.slice(1)
    if (router.path !== currentPath) {
      router.push(currentPath);// 主动更改路由界面
    }
  }, false);
}

router.beforeEach((to, from, next) => {
  if (browser.ua.weixin) { // 微信浏览器

    let mobileURL = routeToMobile(to);

    window.location.href = mobileURL;
    
  }
  else if (browser.ua.mobile && !browser.ua.iPad) { // 手机浏览器
    if (to.name == 'mobile') {
      next();
    } else {
      next('/mobile')
    }
  }
  else {
    if (to.meta.requiresAuth) {
      let token = localStorage.getItem('PUBMEDSEARCHTOKEN');
      if (token) {
        next();
        setTimeout(() => {
          performance()
        }, 1000)
      } else {
        if (to.query.code && to.query.state == 'pclogin') { // 有code ,说明是扫码后登录的回调
          let loadingInstance = Loading.service(
            { fullscreen: true },
            { text: '努力加载中...' },
          );
          // 获取token后跳转到搜索页
          let wxTo = {
            code: to.query.code,
            source: 'pc'
          };
          getToken(wxTo).then(res => {
            loadingInstance.close()
            if (res.data.status == 0) {
              let { token, name, headimgurl, openid } = res.data;
              window.localStorage.setItem('PUBMEDSEARCHTOKEN', token);
              window.localStorage.setItem('PUMMEDSEARCHUSERNAME', name);
              window.localStorage.setItem('PUMMEDSEARCHHEADIMG', headimgurl);
              window.localStorage.setItem('PUBMEDSEARCHOPENID', openid);
              if (window.localStorage.getItem('REDIRECT') && window.localStorage.getItem('REDIRECT') != null) {
                if (window.localStorage.getItem('REDIRECT').indexOf('login') != -1) {
                  next({ path: '/', replace: true });
                } else {
                  window.location.href = window.localStorage.getItem('REDIRECT')
                }
                setTimeout(() => {
                  performance()
                }, 1000)
              } else {
                next({ path: '/', replace: true });
                setTimeout(() => {
                  performance()
                }, 1000)
              }
            } else {
              // alert('登录超时，请重新扫码登录')
              next('/login')
              setTimeout(() => {
                performance()
              }, 1000)
            }
          })
        } else { // 不是微信回掉，直接访问，没有token和code，直接登录
          if (browser.ua.mobile && !browser.ua.iPad) { // 手机浏览器
            next('/mobile')
            return
          }
          next('/login')
          setTimeout(() => {
            performance()
          }, 1000)
        }
      }
    } else {
      let token = localStorage.getItem('PUBMEDSEARCHTOKEN');
      if (token) {
        next()
      } else {
        if (to.query.code && to.query.state == 'pclogin') { // 有code ,说明是扫码后登录的回调
          let loadingInstance = Loading.service(
            { fullscreen: true },
            { text: '努力加载中...' },
          );
          let wxTo = {
            code: to.query.code,
            source: 'pc'
          };
          getToken(wxTo).then(res => {
            loadingInstance.close()
            if (res.data.status == 0) {
              let { token, name, headimgurl, openid } = res.data;
              window.localStorage.setItem('PUBMEDSEARCHTOKEN', token);
              window.localStorage.setItem('PUMMEDSEARCHUSERNAME', name);
              window.localStorage.setItem('PUMMEDSEARCHHEADIMG', headimgurl);
              window.localStorage.setItem('PUBMEDSEARCHOPENID', openid);
              if (window.localStorage.getItem('REDIRECT') && window.localStorage.getItem('REDIRECT') != null) {
                if (window.localStorage.getItem('REDIRECT').indexOf('login') != -1) {
                  next({ path: '/', replace: true });
                } else {
                  window.location.href = window.localStorage.getItem('REDIRECT')
                }
                setTimeout(() => {
                  performance()
                }, 1000)
              } else {
                next({ path: '/', replace: true });
                setTimeout(() => {
                  performance()
                }, 1000)
              }
            } else {
              // alert('登录超时，请重新扫码登录')
              next('/login')
              setTimeout(() => {
                performance()
              }, 1000)
            }
          })
        } else {
          window.localStorage.setItem('REDIRECT', window.location.href);
          next()
          setTimeout(() => {
            performance()
          }, 1000)
        }
      }
      console.log('notrequiresAuth')
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js